import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { OrgHygieneScreen } from '@/features/hr-reports/org-hygiene-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/hr/reports/org-hygiene')({
  validateSearch: (search: Record<string, unknown>) => hrReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: OrgHygieneScreenRoute,
})

function OrgHygieneScreenRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <OrgHygieneScreen
      search={search}
      onSearchChange={(next) => void navigate({ to: '/hr/reports/org-hygiene', search: next })}
    />
  )
}
